<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 170px"
            v-model="filters.numberName"
            placeholder="请输入号码库名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 170px"
            v-model="filters.isEnable"
            placeholder="请选择号码状态"
            clearable
          >
            <el-option
              v-for="item in isEnableOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="省份:">
          <el-select
            style="width: 100px"
            clearable
            v-model="filters.provinceId"
            placeholder="请选择"
            @change="handleProvinceChange"
          >
            <el-option
              v-for="item in provinceOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市:">
          <el-select
            style="width: 100px"
            v-model="filters.cityId"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in cityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导入日期:">
          <el-date-picker
            v-model="filters.searchTimer"
            placeholder="选择日期"
            :unlink-panels="true"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
        </el-form-item>
        <!-- <el-form-item style="margin-left: 20px; margin-top: 5px">
          <span style="color: red;cursor: pointer;" @click="importTemplateDownload "
            >导入模板下载</span
          > -->
          <el-form-item>
            <a style="color:red;" href="/qmxfwebapi/obs/uploadDocumentFile/2026/02/27/%E5%8F%B7%E7%A0%81%E5%BA%93%E6%A8%A1%E6%9D%BF.xls">导入模板下载</a>
          </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      @current-change="selectCurrentRow"
      class="custom-padding-table"
    >
      <el-table-column
        prop="numberName"
        label="号码库名称"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="numberType" label="类型" align="center">
        <template #default="scope">
          <span v-if="scope.row.numberType == 1">基站获取</span>
          <span v-if="scope.row.numberType == 2">广东社会培训项目</span>
          <span v-if="scope.row.numberType == 3">操作员</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isEnable"
        label="号码库状态"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.isEnable == true">启用</el-tag>
          <el-tag type="info" v-if="scope.row.isEnable == false">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="numberCount"
        label="号码个数"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="provinceName"
        label="省份"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="城市"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建日期"
        align="center"
        show-overflow-tooltip
        width="240"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="importPhoneFun(scope.row)"
            >导入号码</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="viewPhoneNumberDetail(scope.row)"
            >查看明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="Form"
        label-width="100px"
        ref="Form"
        style="max-width: 700px"
        :rules="FormRules"
      >
        <el-form-item label="号码库名称：" prop="numberName">
          <el-input
            v-model="Form.numberName"
            auto-complete="off"
            placeholder="请输入号码库名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="号码库状态：" prop="isEnable">
          <el-select
            style="width: 170px"
            v-model="Form.isEnable"
            placeholder="请选择号码状态"
            clearable
          >
            <el-option
              v-for="item in isEnableOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型: " width sortable prop="numberType">
          <el-select
            style="width: 180px"
            clearable
            v-model="Form.numberType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in numberTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="省份: " width sortable prop="provinceId">
          <el-select
            style="width: 100px"
            clearable
            v-model="Form.provinceId"
            placeholder="请选择"
            @change="handleProvinceChange2"
          >
            <el-option
              v-for="item in provinceOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市: " width sortable prop="cityId">
          <el-select
            style="width: 120px"
            v-model="Form.cityId"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in cityOptions2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--导入号码库弹窗-->
    <el-dialog
      title="导入号码"
      :visible.sync="importPhoneVisible"
      v-model="importPhoneVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="importPhoneForm"
        label-width="100px"
        ref="importPhoneForm"
        style="max-width: 700px"
      >
        <el-form-item label="号码库名称：">
          <el-input
            v-model="numberName"
            auto-complete="off"
            placeholder=""
            disabled
          ></el-input>
        </el-form-item>
        <!-- 上传区域 -->
        <el-form-item label="号码库状态: ">
          <el-upload
            ref="upload"
            action=""
            :on-change="handleFileChange"
            :before-upload="beforeUpload"
            :auto-upload="false"
            :show-file-list="true"
            accept=".xls,.xlsx"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择导入文件(Excel)</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="importPhoneVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="importPhoneSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getAreaDictionaryList,
  getPhoneNumberListApi,
  addPhoneNumberApi,
  editPhoneNumberApi,
  addNumberLibraryDetailApi,
} from "../../api/api";
// 修改点：引入 axios 用于发送文件上传请求
import axios from "axios";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Qs from "qs";
export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        numberName: "",
        isEnable: "",
        provinceId: "",
        cityId: "",
        searchTimer: "",
      },

      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      provinceOptions: [],
      cityOptions: [],
      cityOptions2: [],

      //号码状态
      isEnableOptions: [
        {
          value: true,
          label: "启用",
        },
        {
          value: false,
          label: "禁用",
        },
      ],
      numberTypeOptions: [
        {
          value: 1,
          label: "基站获取",
        },
        {
          value: 2,
          label: "广东社会培训项目",
        },
        {
          value: 3,
          label: "操作员",
        },
      ],
      pid: 0,
      FormVisible: false,
      Form: {
        numberName: "",
        isEnable: "",
        numberType: "",
        provinceId: "",
        cityId: "",
      },
      FormRules: {
        numberName: [
          { required: true, message: "请输入号码库名称", trigger: "blur" },
        ],
        isEnable: [
          { required: true, message: "请选择号码库状态", trigger: "blur" },
        ],
        numberType: [
          { required: true, message: "请选择类型", trigger: "blur" },
        ],
        provinceId: [
          { required: true, message: "请选择省份", trigger: "blur" },
        ],
        cityId: [{ required: true, message: "请选择城市", trigger: "blur" }],
      },
      currentRow: "",
      editmark: false,
      importPhoneVisible: false,
      importPhoneForm: {
        numberLibraryId: "",
        file: "",
      },
      numberName: "",
      fileList: [],
    };
  },
  methods: {
    // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    importPhoneSubmit() {
      // 校验是否选择了文件
      if (!this.importPhoneForm.file) {
        this.$message.warning("请先选择要导入的 Excel 文件");
        return;
      }
      // 校验 ID
      if (!this.importPhoneForm.numberLibraryId) {
        this.$message.error("未获取到号码库 ID");
        return;
      }
      this.$confirm("确认提交导入吗？", "提示", {}).then(() => {
        this.listLoading = true;
        // 构造 FormData
        const formData = new FormData();
        formData.append("file", this.importPhoneForm.file);
        formData.append(
          "numberLibraryId",
          this.importPhoneForm.numberLibraryId
        );
        // 发送请求 (使用 axios 直接发送 formData)
        axios
          .post(addNumberLibraryDetailApi, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + this.getToken(),
            },
          })
          .then((res) => {
            this.listLoading = false;
            // 根据你的后端返回结构调整判断条件
            if (res.data.success) {
              this.$message({
                message: res.data.message || "导入成功",
                type: "success",
              });
              this.importPhoneVisible = false;
              this.importPhoneForm.file = null;
              if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
              }
              this.getList(); // 刷新列表
            } else {
              this.$message({
                message: res.data.message || "导入失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.listLoading = false;
            console.error(err);
            this.$message.error(
              "网络请求失败：" + (err.response?.data?.message || err.message)
            );
          });
      });
    },
    // 2. 【新增】文件改变事件：读取二进制文件
    handleFileChange(file) {
      this.importPhoneForm.file = file.raw;
      this.fileList = [file]; // 更新文件列表显示
      this.$message.info("文件已就绪，请点击提交");
    },
    // 获取token
    getToken() {
      return localStorage.getItem("Token");
    },
    // 上传前校验
    beforeUpload(file) {
      const validType = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      const isValidType = validType.includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isValidType) {
        this.$message.error("只能上传 Excel 文件 (.xls 或 .xlsx)！");
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB！");
      }

      return isValidType && isLt10M;
    },

    importPhoneFun(row) {
      this.importPhoneVisible = true;
      this.numberName = row.numberName;
      this.importPhoneForm.numberLibraryId = row.id;
    },
    // 导出模板
    exportMessageExcel() {
      this.listLoading = true;
      function createObjectURL(object) {
        return window.URL
          ? window.URL.createObjectURL(object)
          : window.webkitURL.createObjectURL(object);
      }
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      xhr.open(
        "GET",
        `/omswebapi/message/exportMessageExcel?isAll=${
          this.exportExcelRadio
        }&startDate=${
          this.rangeTimers
            ? this.formatCreateTime(this.rangeTimers[0]) + " 00:00:00"
            : null
        }&endDate=${
          this.rangeTimers
            ? this.formatCreateTime(this.rangeTimers[1]) + " 23:59:59"
            : null
        }`,
        true
      );
      xhr.setRequestHeader(
        "Authorization",
        `Bearer ${window.localStorage.getItem("Token")}`
      );
      xhr.responseType = "blob";
      xhr.onload = function (e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = `聊天记录导出.xlsx`;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement("a");
            var url = createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
      this.listLoading = false;
    },
    getList() {
      let { searchTimer, ...queryFilters } = this.filters;
      var params = {
        ...queryFilters,
        startTime: searchTimer ? this.formatCreateTime(searchTimer[0]) : "",
        endTime: searchTimer ? this.formatCreateTime(searchTimer[1]) : "",
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getPhoneNumberListApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },
    selectCurrentRow(row) {
      this.currentRow = row;
    },
    handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.editmark = true;
      // 深拷贝一下
      this.Form = { ...this.currentRow };
      // 根据省份获取一下城市列表
      this.pid = this.Form.provinceId;
      this.getProvinceCityInfo(2);
      this.FormVisible = true;
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.Form = {
        numberName: "",
        isEnable: "",
        numberType: "",
        provinceId: "",
        cityId: "",
      };
      this.editmark = false;
      this.FormVisible = true;
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
            let params = {
              ...this.Form,
            };
            if (this.editmark) {
              editPhoneNumberApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addPhoneNumberApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.handleSearch();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

    // 当省份改变时重新获取城市
    handleProvinceChange(val) {
      this.filters.cityId = "";
      this.pid = val;
      this.getProvinceCityInfo(1);
    },
    handleProvinceChange2(val) {
      this.Form.cityId = "";
      this.pid = val;
      this.getProvinceCityInfo(2);
    },
    // 获取省市接口
    getProvinceCityInfo(type) {
      var params = {
        pid: this.pid,
      };
      getAreaDictionaryList(params).then((res) => {
        if (type == 0) {
          this.provinceOptions = res.data.response;
        }
        if (type == 1) {
          this.cityOptions = res.data.response;
        }
        if (type == 2) {
          this.cityOptions2 = res.data.response;
        }
      });
    },

    viewPhoneNumberDetail(row) {
      this.$router.push({
        path: "/phoneNumberDatabaseDetail",
        query: { id: row.id, numberName: row.numberName },
      });
    },
    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getProvinceCityInfo(0);
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
